import React, { useState, useEffect } from "react";

const Timer = ({ initialTime, onTimeUp, isPaused }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (isPaused) return; // Nie uruchamiamy odliczania, jeśli pauzowane
    if (timeLeft === 0) {
      onTimeUp(); // Wywołaj funkcję po upływie czasu
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId); // Wyczyść interwał po unmount
  }, [timeLeft, isPaused, onTimeUp]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <div className={`timer ${timeLeft <= 300 ? "timer--warning" : ""}`}>
      <h3>Czas: {formatTime(timeLeft)}</h3>
    </div>
  );
};

export default Timer;
